"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTable = exports.STANDARD_ROW_HEIGHT = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const table_error_overlay_1 = require("../table-error-overlay");
const components_1 = require("./components");
const product_table_pagination_renderer_component_1 = require("./components/product-table-pagination-renderer.component");
const hooks_1 = require("./hooks");
const get_filter_component_settings_utils_1 = require("./utils/get-filter-component-settings.utils");
exports.STANDARD_ROW_HEIGHT = 68;
const ProductTable = (props) => {
    const { columns, slots, slotProps, tableRowSize, error, onEditAttribute, hasSelection = false, enableMultiFiltering = false, pageRowsLoadStatus, filterModel, sortModel, pageSizeOptions, onContextMenu, initialState, columnsOrder, onColumnOrderChange, isRowDisabled, isHeaderSelectionDisabled = false, isCellEditable, isRowSelectable, getRowClassName } = props, restProps = __rest(props, ["columns", "slots", "slotProps", "tableRowSize", "error", "onEditAttribute", "hasSelection", "enableMultiFiltering", "pageRowsLoadStatus", "filterModel", "sortModel", "pageSizeOptions", "onContextMenu", "initialState", "columnsOrder", "onColumnOrderChange", "isRowDisabled", "isHeaderSelectionDisabled", "isCellEditable", "isRowSelectable", "getRowClassName"]);
    const getRowHeight = (0, react_1.useCallback)(() => {
        if (tableRowSize === ui_components_1.DataGridRowSize.Adaptive) {
            return 'auto';
        }
        if (tableRowSize === ui_components_1.DataGridRowSize.Standard) {
            return exports.STANDARD_ROW_HEIGHT;
        }
    }, [tableRowSize]);
    const { isCellEditable: mergedIsCellEditable, isRowSelectable: mergedIsRowSelectable, getRowClassName: mergedGetRowClassName, } = (0, hooks_1.useDisabledRows)({
        isRowDisabled,
        isCellEditable,
        isRowSelectable,
        getRowClassName,
    });
    const mergedInitialState = (0, react_1.useMemo)(() => (Object.assign({ pinnedColumns: {
            left: [ui_components_1.GRID_CHECKBOX_SELECTION_COL_DEF.field],
        } }, initialState)), [initialState]);
    // TODO: Optimize reordering logic
    const handleColumnOrderChange = (0, react_1.useCallback)(({ targetIndex, column }) => {
        if (!onColumnOrderChange || !columnsOrder)
            return;
        const fromIndex = columnsOrder.findIndex((itemId) => itemId === column.field);
        if (fromIndex < 0)
            return;
        const targetColumn = columns[targetIndex - 1];
        const toIndex = targetColumn ? columnsOrder.findIndex((itemId) => itemId === targetColumn.field) : -1;
        const newLocalColumnsOrder = [...columnsOrder];
        newLocalColumnsOrder.splice(fromIndex, 1);
        newLocalColumnsOrder.splice(toIndex < 0 ? newLocalColumnsOrder.length : toIndex, 0, column.field);
        onColumnOrderChange(newLocalColumnsOrder);
    }, [columns, columnsOrder, onColumnOrderChange]);
    const excludedOperatorValues = (0, react_1.useMemo)(() => (enableMultiFiltering ? Array.from((0, ui_components_1.getPanelOnlyOperatorValues)()) : undefined), [enableMultiFiltering]);
    const renderPageNavigation = (0, react_1.useCallback)((model) => (0, product_table_pagination_renderer_component_1.renderProductTablePageNavigation)({
        model,
        pageRowsLoadStatus,
    }), [pageRowsLoadStatus]);
    const NoRowsOverlay = error ? table_error_overlay_1.TableErrorOverlay : ui_components_1.DataGridNoResults;
    const shouldShowToolbar = enableMultiFiltering
        || filterModel.items.length > 0
        || sortModel.length > 0;
    return (react_1.default.createElement(ui_components_1.AdvancedDataGrid, Object.assign(Object.assign({ sx: Object.assign(Object.assign({ '& .MuiDataGrid-toolbar': {
                alignItems: 'center',
            }, '& .MuiDataGrid-row--dynamicHeight > .MuiDataGrid-cell': {
                display: 'flex',
                alignItems: 'center',
            }, '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainerContent': {
                justifyContent: 'center',
            }, '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer > button': {
                display: 'none',
            } }, (isHeaderSelectionDisabled && {
            '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
                opacity: 0.45,
                pointerEvents: 'none',
            },
        })), { '& .MuiDataGrid-row.Mui-disabled-row': {
                backgroundColor: ui_components_1.baseColors.background000,
                '& .MuiDataGrid-cell': {
                    cursor: 'default',
                    color: ui_components_1.baseColors.gray300,
                    '&.MuiDataGrid-cell--pinnedLeft, &.MuiDataGrid-cell--pinnedRight': {
                        backgroundColor: ui_components_1.baseColors.background000,
                    },
                },
            }, '& .MuiDataGrid-row .disabled-cell': {
                cursor: 'default',
                color: ui_components_1.baseColors.gray300,
                backgroundColor: ui_components_1.baseColors.background000,
            }, backgroundColor: 'transparent' }), columns: columns, showToolbar: shouldShowToolbar, pagination: true, pageSizeOptions: pageSizeOptions, 
        // for server side pagination/filtering/sorting
        paginationMode: "server", sortingMode: "server", filterMode: "server", filterModel: filterModel, sortModel: sortModel, keepNonExistentRowsSelected: true, hideFooterSelectedRowCount: true, checkboxSelection: true, disableMultipleRowSelection: false, checkboxSelectionVisibleOnly: true, isCellEditable: mergedIsCellEditable, isRowSelectable: mergedIsRowSelectable, getRowClassName: mergedGetRowClassName, showCellVerticalBorder: true, showColumnVerticalBorder: true, enableVirtualization: true, virtualizeColumnsWithAutoRowHeight: true }, restProps), { slots: Object.assign(Object.assign({ basePagination: ui_components_1.PaginationContainer, noRowsOverlay: NoRowsOverlay, toolbar: components_1.ToolbarLayout, columnHeaderFilterIconButton: ui_components_1.FilterContainer }, (enableMultiFiltering && { filterPanel: ui_components_1.MultiFilterPanel })), slots), slotProps: Object.assign({ noRowsOverlay: { noResultsText: error || 'No data to display' }, loadingOverlay: {
                noRowsVariant: 'skeleton',
                variant: 'skeleton',
            }, basePagination: {
                enablePageSizeSelectorControl: true,
                enablePageNavigation: true,
                enableEdgeButtons: true,
                pageNavigationControlRender: renderPageNavigation,
                // TODO: Investigate why `rowsPerPageOptions` occasionally disappears when not passed directly
                rowsPerPageOptions: pageSizeOptions,
            }, cell: {
                onContextMenu,
            }, columnHeaderFilterIconButton: Object.assign(Object.assign({}, get_filter_component_settings_utils_1.filterComponentProps), (excludedOperatorValues && { excludedOperatorValues })), toolbar: { enableMultiFiltering }, columnMenu: {
                slots: Object.assign(Object.assign({}, (enableMultiFiltering ? {} : { columnMenuFilterItem: null })), { columnMenuUserItem: components_1.EditColumnMenuItem }),
                slotProps: {
                    columnMenuUserItem: {
                        displayOrder: 0,
                        onEdit: onEditAttribute,
                        hasSelection,
                    },
                },
            } }, slotProps), density: tableRowSize === ui_components_1.DataGridRowSize.Adaptive ? 'comfortable' : 'standard', getRowHeight: getRowHeight, disableColumnMenu: false, initialState: mergedInitialState, onColumnOrderChange: handleColumnOrderChange })));
};
exports.ProductTable = ProductTable;
